import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapFallsUnderToApiFallsUnderDto = (values: IUpdateFallsUnderForm): IUpdateFallsUnder | {} => {
  let dataMapping: IUpdateFallsUnder;

 
  dataMapping = {
    unitID: +values.unitID,
    unitType: values.unitType,
    comments: values.comments
  }
  
  return dataMapping;
}


export const createFallsUnder = ( {data, establishmentId} : {data: IUpdateFallsUnderForm , establishmentId: number}): Promise<string> => {
  const falls = mapFallsUnderToApiFallsUnderDto(data);
  return axiosDefaultApi.post(`/api/FallsUnders/InsertFallsUnder/${establishmentId}`, falls);
};

type QueryFnType = typeof createFallsUnder;

type UseCreateFallsUnderOptions = {
  data: IUpdateFallsUnder | {};
  establishmentId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useCreateFallsUnder = ({ config }: UseCreateFallsUnderOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του "Υπάγεται στο".`, 500);
            console.error('Couldnt create new falls under', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllFallsUnders"])
            addNotification(`Το "Υπάγεται στο" Δημιουργήθηκε.`, 500);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createFallsUnder,
    })
}